import React, { useEffect } from 'react';
import Config from '../../Config';
import { withRouter, useHistory, } from 'react-router-dom';
import { useAuth0 } from "@auth0/auth0-react";
const LogOut = (props) => {

    let history = useHistory();
    const { logout } = useAuth0();
    useEffect(async () => {
        localStorage.setItem('islogin', false);
        localStorage.removeItem('loginName');
        localStorage.removeItem('loginUserID');
        localStorage.removeItem('loginEmail');
        localStorage.removeItem('loginRoleName');
        localStorage.removeItem('Auth0ID');
        localStorage.removeItem('Auth0token');
        localStorage.removeItem('Pricingpage');
        localStorage.removeItem("CurrencyID");
        localStorage.removeItem("ProductsID");
        localStorage.removeItem("IsMonthly");
        localStorage.clear();
        // history.push('/Login');
        // await logout();
        await callLogout();
        // history.push('Login');
        // history.push('/Login');
        // history.push({
        //     pathname: '/Login' });
        // history.push('/Login');
    }, []);


    const callLogout = async () => {
        // await logout();
        await logout()
        // setTimeout(() => {
        //     history.push('/Login')
        // }, 300);
        // history.push('/Login')
    }
    return (
        <>
        </>
    );
}
export default LogOut;